import { Reveal } from "./Reveal";
import { GALLERY } from "@/data/content";

export default function Gallery({ filter, eyebrow = "Galerie", title = "Clinica noastră în imagini", subtitle = "Cabinete moderne, elegante și dotate cu aparatură de ultimă generație — un mediu în care te simți în siguranță.", bg = "bg-white" }) {
  const items = filter ? GALLERY.filter((g) => g.cat === filter) : GALLERY;
  if (items.length === 0) return null;

  return (
    <section id="galerie" className={`py-20 lg:py-28 ${bg}`}>
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">{eyebrow}</span>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">{title}</h2>
          <p className="text-[#6B5C43] mt-4 text-lg">{subtitle}</p>
        </Reveal>

        <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-5">
          {items.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className="mb-5 break-inside-avoid">
              <div className="relative group rounded-2xl overflow-hidden shadow-md shadow-[#A6823B]/10" data-testid="gallery-image">
                <img src={g.src} alt={g.label} loading="lazy"
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#2A2521]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-white font-medium text-sm">{g.label}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
